// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorContent_wrapper__1rybw"};